import React from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from './sidebar/Sidebar';
import { Services } from '../api/Services';
import ReactPaginate from 'react-paginate';
import { useEffect,useState } from 'react';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const ExerciseList = () => {
    const [pageCount, setPageCount] = useState(0);
    const [exercises,setExercises]=useState([])
    const [loading,setLoading]=useState(false)
    const [keyword,setkeyword]=useState('')
    const [cloader,setCloader] =useState(false)
    const [generalFields, setGeneralFields] = useState();
    const [cmodal, setCmodal] = useState(false)
    const [editmodal,setEditModal]=useState(false)
    const [exerciseId,setExerciseId]=useState('')
    const [selectedFields, setSelectedFields] = useState([]);
    const [newExercise, setNewExercise] = useState({
        name: '',
        video: '',
        fields: [],
      });
    //handle keyword search
 

   const handleExerciseSearch  = (e)=> {
   
  
      setkeyword(e.target.value)
    
   }
    
  //fetch general fields 

   const generalField = async () => {

    try {
      const result = await Services.getgeneralFields()

      if (result.status === 200) {
        setGeneralFields(result?.data?.data)




      }
      else {

        toast.error("Some error", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      console.log(error);

    }
  }


   // handle excercise create chaneg
  const handleNewExerciseChange = (event) => {
    const { name, value } = event.target;
    setNewExercise((prevExercise) => ({
      ...prevExercise,
      [name]: value,
    }));
  };




  const handleFieldSelection = (field) => {
    if (selectedFields.some((selectedField) => selectedField.measurement_id === field.measurement_id)) {
      // Deselect the field
      setSelectedFields((prevSelectedFields) =>
        prevSelectedFields.filter((selectedField) => selectedField.measurement_id !== field.measurement_id)
      );
    } else if (selectedFields.length < 2) {
      // Select the field if less than 2 fields are selected
      setSelectedFields((prevSelectedFields) => [...prevSelectedFields, field]);
    }
  };


 //get Excercises list
 const getTrainerExercisesList = async (page,keyword) => {
    if(!keyword) {
        setLoading(true)
    }
    try {
      const result = await Services.getTrainerExercises(page,keyword)
    
      if (result.status === 200) {

        console.log(result)
        setExercises(result?.data?.data)
        setPageCount(result?.data?.paging?.total_pages)
        setLoading(false)

      }
      else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER
        });
      }
    } catch (error) {
      console.log(error);

    }
  }

// handle page count
  const handlePageClick = (event) => {
    
     
    getTrainerExercisesList(event.selected + 1);
    
  };


  useEffect(()=>{
    getTrainerExercisesList(pageCount,keyword)
  },[pageCount,keyword])

useEffect(()=>{
    generalField()
},[])





  const createNewExercise = async () => {

    if (newExercise.name.trim() === '') {
      // Handle validation, such as empty exercise name or no selected fields
      toast.error("please enter excercise name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER
      });
    }
    else if (selectedFields.length === 0) {
      toast.error("please select atleast one field", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER
      });
    }
    else {

      const exerciseToAdd = {
        name: newExercise.name,
        video: newExercise.video,
        fields: selectedFields,
      };

    setCloader(true)
      try {
        const result = await Services.createExercise(exerciseToAdd)

        if (result.status === 200) {
          
        getTrainerExercisesList(pageCount,keyword)
            toast.success(result?.data?.message, {
                autoClose: 2000,
                pauseOnHover: true,
                draggable: true,
                position: toast.POSITION.TOP_CENTER
              });


        }
        else {

          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER
          });
        }
        setCloader(false)
      } catch (error) {
        console.log(error);

      }






      setNewExercise({
        name: '',
        video: '',
      });

      setSelectedFields([]); // Clear the selected fields
      setCmodal(false); // Close the modal
    }

  };

//edit excercise

const editExercise = (exer)=>{
    setSelectedFields([])
    setExerciseId(exer?.id)
    setNewExercise((prev) => ({
        ...prev,
        name: exer?.name,
        video: exer?.video,
      }));
      exer?.input?.map((field)=> {
        setSelectedFields((prevSelectedFields) => [...prevSelectedFields, {field:field?.field_name,measurement_id:field?.measurement_id}]);
      })
      setEditModal(true)
      
}


//api call for edit excercise


const editExerciseNow = async () => {

    if (newExercise.name.trim() === '') {
      // Handle validation, such as empty exercise name or no selected fields
      toast.error("please enter exercise name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER
      });
    }
    else if (selectedFields.length === 0) {
      toast.error("please select atleast one field", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER
      });
    }
    else {

      const exerciseToAdd = {
        id:exerciseId,
        name: newExercise.name,
        video: newExercise.video,
        fields: selectedFields,
      };

    setCloader(true)
      try {
        const result = await Services.editExercise(exerciseToAdd)

        if (result.status === 200) {
          
        getTrainerExercisesList(pageCount,keyword)
            toast.success(result?.data?.message, {
                autoClose: 2000,
                pauseOnHover: true,
                draggable: true,
                position: toast.POSITION.TOP_CENTER
              });


        }
        else {

          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER
          });
        }
        setCloader(false)
      } catch (error) {
        console.log(error);

      }






      setNewExercise({
        name: '',
        video: '',
      });

      setSelectedFields([]); // Clear the selected fields
      setEditModal(false); // Close the modal
    }

  };




  
  return (
    <div className="wrapper-dashboard create-workout">

        {cloader && <div className='loaderparent'>
            <div className="loader">

            </div>
            </div>}
        {cmodal &&
        <div className="excercise-modal">

          <div className="child-modal">
            <div className="add-excersie">
              <span></span>
              <i className="fa fa-times" onClick={() => setCmodal(false)}></i>
            </div>
            <div className="exercise-form">
              <div className="form-group mb-3">
                <input
                  type="text"
                  name="name"
                  className='form-control input'
                  value={newExercise.name}
                  onChange={handleNewExerciseChange}
                  placeholder="Exercise Name"
                />
              </div>
              <div className="form-group mb-3">
                <input
                  type="text"
                  className='form-control input'
                  name="video"
                  value={newExercise.video}
                  onChange={handleNewExerciseChange}
                  placeholder="Video Link"
                />
              </div>
              <div className='mb-3'>
                <label>Select Fields (up to 2)</label>
                <ul>
                  {generalFields?.map((field) => (
                    <li key={field.measurement_id}>
                      <label>
                        <input
                          type="checkbox"
                          checked={selectedFields?.some((selectedField) => selectedField.measurement_id === field.measurement_id)}
                          onChange={() => handleFieldSelection(field)}
                          disabled={selectedFields.length >= 2 && !selectedFields.some((selectedField) => selectedField.measurement_id === field.measurement_id)}
                        />
                        {field.field}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
              <button className='button' onClick={() => createNewExercise()}>Create Exercise</button>
            </div>

          </div>
        </div>
      }
      {editmodal &&
        <div className="excercise-modal">

          <div className="child-modal">
            <div className="add-excersie">
              <span></span>
              <i className="fa fa-times" onClick={() => setEditModal(false)}></i>
            </div>
            <div className="exercise-form">
              <div className="form-group mb-3">
                <input
                  type="text"
                  name="name"
                  className='form-control input'
                  value={newExercise.name}
                  onChange={handleNewExerciseChange}
                  placeholder="Exercise Name"
                />
              </div>
              <div className="form-group mb-3">
                <input
                  type="text"
                  className='form-control input'
                  name="video"
                  value={newExercise.video}
                  onChange={handleNewExerciseChange}
                  placeholder="Video Link"
                />
              </div>
              <div className='mb-3'>
                <label>Select Fields (up to 2)</label>
                <ul>
                  {generalFields?.map((field) => (
                    <li key={field.measurement_id}>
                      <label>
                        <input
                          type="checkbox"
                          checked={selectedFields?.some((selectedField) => selectedField.measurement_id === field.measurement_id)}
                          onChange={() => handleFieldSelection(field)}
                          disabled={selectedFields.length >= 2 && !selectedFields.some((selectedField) => selectedField.measurement_id === field.measurement_id)}
                        />
                        {field.field}
                      </label>
                    </li>
                  ))}
                </ul>
              </div>
              <button className='button' onClick={() => editExerciseNow()}>Edit Exercise</button>
            </div>

          </div>
        </div>
      }
         <ToastContainer />
      <div className="left">

        <Sidebar />
      </div>

      <div className='right'>
        <div className="trainer_exercisr_list">
            <div className="trainer-header">
            <span className="title">
                Trainer exercises
            </span>
            <button onClick={()=>setCmodal((pre)=> !pre)}>Add exercise</button>
            </div>
            {!loading && 
           
           <>
           <div className="excercise-input">
            <input type="text" placeholder='Search exercise' value={keyword} onChange={handleExerciseSearch}/>
           </div>
           <div className="table-responsive mytable">
           <table className="table table-hover ">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col" >Exercise Title</th>
      <th scope="col" >Fields</th>
      <th scope="col" >Action</th>
      <th scope="col">Media</th>
    </tr>
  </thead>
 
  <tbody>
  {exercises?.map((exer,index)=><tr key={exer?.id}>
    <th>{index + 1}</th>
    <td >{exer?.name}</td>
    <td > <ul className='fieldss'>
                    {exer?.input?.map((inp)=><li key={inp?.id}>{inp?.field_name}</li>)}
                </ul></td>
                <td >
                <i className="fa fa-pencil" onClick={()=>editExercise(exer)}></i>
                </td>
                <td>{exer?.video !=null && <a href={exer?.video} target='_blank'><i className="fa fa-video"></i></a>}</td>
  </tr>)}
  </tbody>
</table>
</div>
          
           
           
           </>

            }
        {!loading && exercises?.length === 0 && <p className='no-exercise'>No Exercise Found !</p>}
            
            {loading &&  <div className="exercise-container">
                <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
               <div className="exercise">
                <Skeleton height={25} duration={1.5} />
                <Skeleton height={2} duration={1.5} />
                </div>
                
            
            </div>}

        </div>
      { pageCount > 1 && 
            <div style={{float:'right', marginTop:'20px', marginRight:'10px'}}>
              <nav aria-label="Page navigation example">
                <ReactPaginate
                  className="pagination pull-right"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< "
                    activeClassName="active"
                    renderOnZeroPageCount={false}
                />
                </nav>
            </div>
          }
       

      </div>
        </div>
  )
}

export default ExerciseList